import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import IdentifiersListView from "./identifiers-list.html";
import IdentifiersEditView from "./identifiers-edit.html";


angular.module("identifiers", [])

    .config(['$stateProvider' ,function ($stateProvider) {
        $stateProvider
            .state('identifiers', {
                url: "/identifiers",
                abstract: true,
                cache: false,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('identifiers.list', {
                url: "/list",
                cache: false,
                controller: "IdentifiersListCtrl",
                template: IdentifiersListView,
                data: { pageTitle: 'Identificadores' }
            })
            .state('identifiers.edit', {
                url: "/edit/:id",
                cache: false,
                controller: "IdentifiersEditCtrl",
                template: IdentifiersEditView,
                data: { pageTitle: 'Identificadores' }
            })
        ;
    }])
;